/**
 * 配置上传文件、图片、视频的公共链接地址
 * 
 * baseUrl: 上传地址
 */
// let baseUrl = 'https://betaadminapi.iacecoach.cn/common/uploadFile/'
// 引入
let baseurl = process.env.BASE_API
// console.log('接口baseurl', baseurl)

// 图搜搜上传图片地址
// let imgUploadUrl = 'https://vue.cnfzflw.com/index/algorithm/picUpload'
let imgUploadUrl = baseurl + 'index/algorithm/picUpload'

// 个人中心-发布采购信息/会员服务选择会员中的图片上传地址
// let imgUpload_public = 'https://vue.cnfzflw.com/index/person/picUpload'	
let imgUpload_public = baseurl + 'index/person/picUpload'	

// 个人中心-发布供应信息上传图片
// let imgUpload_gongying = 'https://vue.cnfzflw.com/index/algorithm/goodsPicUpload'	
let imgUpload_gongying = baseurl + 'index/algorithm/goodsPicUpload'	



export {
  imgUploadUrl,
  imgUpload_public,
  imgUpload_gongying
}



// WEBPACK FOOTER //
// ./src/config/env.js